export const filterTree = (node, search) => {
  if (!node.children) return [];

  const matchedChildren = node.children.map((child) => filterTree(child, search)).filter(Boolean);

  const isMatch = node.name?.toLowerCase().includes(search);

  if (isMatch || matchedChildren.length > 0) {
    return {
      ...node,
      children: matchedChildren,
    };
  }

  return null;
};
